import React, { useEffect, useState } from "react";
import { getInitials } from "../../utils/generatefilename";
import api from "../../api/api";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { xpand } from "../svg/iconsvg";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const BENEFITS_LIST = [
  "Visit",
  "Labs",
  "EKG",
  "Ultrasound",
  "Sleep Study",
  "Echo",
  "Injection",
];
const EditBalanceCard = ({ isOpen, onClose,  changestatus,profile,onSave, colors }) => {
 const [getpaymentData, setGetpaymentData] = useState(null);
 const [selectedStatus, setSelectedStatus] = useState({
  color: "",
  label: "",
});
const [isBenefitsOpen, setIsBenefitsOpen] = useState(false);

const [selectedBenefits, setSelectedBenefits] = useState([]);
   const [formData, setFormData] = useState({

     copay: "",
     coinsurance: "",
     deductible: "",
     selfpay:'',
     
   });
  const practiseid = getPracticeId();
  const userConfig = useSelector((state) => state.userconfig);
 const toNumber = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const handleFieldChange = (key, value) => {
  setFormData((prev) => {
    // Coinsurance reduces copay proportionally
    if (key === "coinsurance") {
      const coinsurancePercent = Number(value) || 0;
      const originalCopay = Number(prev.copay) || 0;

      const reducedCopay =
        originalCopay -
        (originalCopay * coinsurancePercent) / 100;

      return {
        ...prev,
        coinsurance: value,
        copay: Math.max(0, reducedCopay.toFixed(2)),
      };
    }

    return {
      ...prev,
      [key]: value,
    };
  });
};

// const handleFieldChange = (key, value) => {
//   setFormData((prev) => ({
//     ...prev,
//     [key]: value,
//   }));
// };
const handleStatus = async (selectedColor) => {
    const formattedStartDate = dayjs(profile.startdate).format('YYYY-MM-DD');
    const payload = {
      patient_name: `${profile.firstname} ${profile.lastname}`,
      appointmentid: profile.appointmentid,
      amount: selectedColor,
      type: "dele",
      searchdate: formattedStartDate,
      createdby: userConfig?.username,
    };

    try {
      await api.put(`/v1/${practiseid}/appointments/patient/${profile.patientid}/payment/update`, payload);
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };
  const handleUpdatePay = async (currentPatient) => {
  const formattedStartDate = dayjs(currentPatient.startdate).format("YYYY-MM-DD");

  // 👇 PRIORITY: formData → API → 0
  const copay =
    toNumber(formData.copay) ||
    toNumber(getpaymentData?.data?.copay);

  const deductible =
    toNumber(formData.deductible) ||
    toNumber(getpaymentData?.deductibleamt);

  const coinsurance =
    toNumber(formData.coinsurance) ||
    toNumber(getpaymentData?.coinsurance);

const selfpay =
  toNumber(formData.selfpay) ||
  toNumber(getpaymentData?.selfpay);

  const acctbalance = toNumber(getpaymentData?.acctbalance);

  const initialTotal =
    copay +
    deductible +
    selfpay +
    acctbalance;

  const payload = {
    patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
    appointmentid: currentPatient.appointmentid,
    location: "Practice App",
    insurance: currentPatient.insurancename || "",

    // ✅ INPUT FIELD PRIORITY VALUES
    copay: copay,
    deductibleamt: deductible,
    coinsurancepercent: coinsurance,

    selfpaybalance: selfpay,
    accountbalance: acctbalance,

    amount: initialTotal,
    searchdate: formattedStartDate,
    createdby: userConfig?.username,
  };

  try {
    await api.put(
      `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`,
      payload
    );
  } catch (error) {
    console.error("Error submitting payment:", error);
  }
};
    const handleGetPayment = async ({ data }) => {
    if(!data?.appointment_date)return
    const dateString = data?.appointment_date;
    const formattedDate = new Date(dateString).toLocaleDateString('en-CA');
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${data?.patientid}/view-payments`, {
        appointmentid: data.appointmentid,
        startdate: formattedDate,
      });
      if (response.status === 200) {
        setGetpaymentData(response.data);
       setFormData({
  ...formData,
  copay: Number(response?.data?.copay) || 0,
  deductible: Number(response?.data?.deductibleamt) || 0,
  coinsurance: Number(response?.data?.coinsurance) || 0,
  selfpay:Number(response?.data?.selfpay) || 0,
});
      }else{
        setGetpaymentData('')
      }
    } catch (error) {
      console.error('Error fetching payment:', error);
    }
  };
  useEffect(()=>{
    if(!profile)return
handleGetPayment({data:profile})
setSelectedBenefits(profile?.ins_config?.benefits || []);
  },[profile])
  const handleCheckboxChange = (color, label) => {
  setSelectedStatus({ color, label });
  handleStatus(color); // API call
};
const toggleBenefit = (benefit) => {
  setSelectedBenefits((prev) =>
    prev.includes(benefit)
      ? prev.filter((b) => b !== benefit)
      : [...prev, benefit]
  );
};
const handleAddBenefits = () => {
  if (!selectedBenefits.length) return;

  onSave({
    patientid: profile.patientid,
    ins_status: "P",
    isexit: false,
    ins_config: {
      ...profile.ins_config,
      benefits: selectedBenefits,
      updatedby: userConfig?.username,
      updatedon: dayjs().toISOString(),
    },
  });
};
const unassigndevice=async()=>{
  try {
    
  } catch (error) {
    console.log(error)
  }finally{
    
  }
}

  if (!isOpen || !profile) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 overflow-y-auto">
      <div className="min-h-screen flex items-start justify-center py-10">
        <div className="w-[360px] rounded-[14px] bg-white shadow-lg">

          {/* ================= HEADER ================= */}
        <div className="flex items-center justify-between rounded-t-[14px] bg-[#1D2951] px-4 py-3 text-white">
                   <div className="flex items-center gap-3">
                  <div
         className="relative flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold text-[#1D2951] overflow-hidden"
         style={{
           backgroundColor: colors?.[profile?.ins_status] || "#9CA3AF",
         }}
       >
         <img
           src={patientPhotoUrl(profile?.patientid)}
           alt={`${profile?.firstname} ${profile?.lastname}`}
           className="absolute inset-0 h-full w-full object-cover"
           onLoad={(e) => {
             // hide initials when image loads
             e.target.nextSibling.style.display = "none";
           }}
           onError={(e) => {
             // hide broken image, keep initials
             e.target.style.display = "none";
           }}
         />
       
         {/* Initials fallback */}
         <span className="relative z-10">
           {getInitials(profile?.firstname, profile?.lastname)}
         </span>
       </div>
       
       
                     <div className="text-sm text-start">
                       <p className="font-semibold">
                         {profile.firstname} {profile.lastname}
                       </p>
                       <p className="text-xs opacity-80">
                         {profile.insurance || "-"}
                       </p>
       
                       <div className="flex gap-4 items-center">
                         <span className="text-xs opacity-80">
                           Subscriber ID: {profile.subscriber_id || "-"}
                         </span>
                         <span className="text-xs opacity-80">
                           Group ID: {profile.group_id || "-"}
                         </span>
                       </div>
                     </div>
                   </div>
       
                   <button onClick={onClose} className="text-lg font-bold">
                     ×
                   </button>
                 </div>

          {/* ================= BODY ================= */}
          <div className="p-4 space-y-4 text-sm text-start">

            {/* Status Indicators */}
      <div className="flex justify-between rounded-[10px] bg-[#F9FAFB] border px-4 py-3">

  {/* Covered */}
  <div
    onClick={() => handleCheckboxChange('58D68D', 'Covered')}
    className="flex flex-col items-center text-xs cursor-pointer"
  >
    <span
      className="h-5 w-5 rounded-full flex items-center justify-center text-white text-[10px]"
      style={{ backgroundColor: '#58D68D' }}
    >
      {selectedStatus.label === 'Covered' ? '✓' : ''}
    </span>
    <span className="mt-1 text-gray-500">Covered</span>
  </div>

  {/* Coinsurance */}
  <div
    onClick={() => handleCheckboxChange('F9E79F', 'Coinsurance')}
    className="flex flex-col items-center text-xs cursor-pointer"
  >
    <span
      className="h-5 w-5 rounded-full flex items-center justify-center text-white text-[10px]"
      style={{ backgroundColor: '#F9E79F' }}
    >
      {selectedStatus.label === 'Coinsurance' ? '✓' : ''}
    </span>
    <span className="mt-1 text-gray-500">Coinsurance</span>
  </div>

  {/* Deductible */}
  <div
    onClick={() => handleCheckboxChange('F3082C', 'Deductible')}
    className="flex flex-col items-center text-xs cursor-pointer"
  >
    <span
      className="h-5 w-5 rounded-full flex items-center justify-center text-white text-[10px]"
      style={{ backgroundColor: '#F3082C' }}
    >
      {selectedStatus.label === 'Deductible' ? '✓' : ''}
    </span>
    <span className="mt-1 text-gray-500">Deductible</span>
  </div>

</div>


  <div className=" font-semibold text-[#1D2951] ">
                $ Payment Details
              </div>

            {/* Payment Details */}
          <div className="rounded-[10px] border">
  {/* Co-pay */}
  <div className="flex justify-between px-4 py-2 border-b">
    <span className="text-gray-600">Co-pay</span>
    <input
      type="number"
      value={formData.copay}
      onChange={(e) => handleFieldChange("copay", e.target.value)}
      onBlur={() => handleUpdatePay(profile)}
      className="w-[80px] text-right font-medium outline-none bg-transparent"
    />
  </div>

  {/* Balance (read-only) */}
  <div className="flex justify-between px-4 py-2 border-b">
    <span className="text-gray-600">Balance</span>
    <span className="font-medium">
      ${getpaymentData?.acctbalance || 0}
    </span>
  </div>

  {/* Deductible */}
  <div className="flex justify-between px-4 py-2 border-b">
    <span className="text-gray-600">Deductible</span>
    <input
      type="number"
      value={formData.deductible}
      onChange={(e) => handleFieldChange("deductible", e.target.value)}
      onBlur={() => handleUpdatePay(profile)}
      className="w-[80px] text-right font-medium outline-none bg-transparent"
    />
  </div>

  {/* Coinsurance */}
  <div className="flex justify-between px-4 py-2 border-b">
    <span className="text-gray-600">Coinsurance (%)</span>
    <input
      type="number"
      value={formData.coinsurance}
      onChange={(e) => handleFieldChange("coinsurance", e.target.value)}
      onBlur={() => handleUpdatePay(profile)}
      className="w-[60px] text-right font-medium outline-none bg-transparent"
    />
  </div>

  {/* Self Pay */}
  <div className="flex justify-between px-4 py-2 border-b">
    <span className="text-gray-600">Self Pay</span>
   <input
  type="number"
  value={formData.selfpay}
  onChange={(e) => handleFieldChange("selfpay", e.target.value)}
  onBlur={() => handleUpdatePay(profile)}
  className="w-[80px] text-right font-medium outline-none bg-transparent"
/>

  </div>

  {/* Total */}
  <div className="flex justify-between px-4 py-3 bg-gray-50 font-semibold">
    <span>Total</span>
    <span className="text-[#1D2951]">
      $
      {(
        Number(formData.copay || 0) +
        Number(formData.deductible || 0) +
        Number(getpaymentData?.selfpay || 0) +
        Number(getpaymentData?.acctbalance || 0)
      ).toFixed(2)}
    </span>
  </div>
</div>


            {/* Coverage Information */}
         <div className="rounded-[10px] border p-4 text-center relative">
  {/* Header */}
  <p className="text-xs text-[#1D2951] font-medium mb-3">
    Coverage Information
  </p>

  {/* Expand icon – top right */}
  <div
  className="absolute top-3 right-3 cursor-pointer"
  onClick={() => setIsBenefitsOpen(true)}
>
  {xpand}
</div>


  {/* Benefits */}
  <div className="flex justify-center gap-2 flex-wrap">
    {selectedBenefits?.map((benefit, index) => (
      <span
        key={benefit}
        className={`rounded-full px-3 py-1 text-xs ${
          [
            'bg-orange-500 text-white',
            'bg-gray-200 text-gray-800',
            'bg-teal-500 text-white',
          ][index % 3]
        }`}
      >
        {benefit}
      </span>
    ))}
  </div>
</div>

          </div>

          {/* ================= FOOTER ================= */}
          <div className="space-y-2 border-t px-4 py-4">
            <div className="flex gap-2">
              <button onClick={() =>
      changestatus({
        patientid: profile.patientid,
        status: "A",
      })
    } className="w-full rounded-[10px] bg-[#4E8A9E] py-2 text-white flex items-center justify-center gap-1">
                ✓ Approve
              </button>
              <button
                onClick={() =>
      changestatus({
        patientid: profile.patientid,
        status: "R",
      })
    } className="w-full rounded-[10px] bg-red-500 py-2 text-white flex items-center justify-center gap-1">
                ✕ Reject
              </button>
            </div>

            <button
              onClick={onClose}
              className="w-full rounded-[10px] border py-2 text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      {isBenefitsOpen && (
  <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center">
    <div className="w-[340px] rounded-[12px] bg-white shadow-lg">

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <p className="text-sm font-semibold text-[#1D2951]">
          Insurance Coverage
        </p>
        <button
          onClick={() => setIsBenefitsOpen(false)}
          className="text-gray-500 text-lg"
        >
          ×
        </button>
      </div>

      {/* Body */}
      <div className="p-4 text-sm">
        <p className="text-xs text-gray-500 mb-3">
          Covered Benefits
        </p>

        <div className="space-y-2">
          {BENEFITS_LIST.map((benefit) => (
            <label
              key={benefit}
              className="flex items-center gap-2 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedBenefits.includes(benefit)}
                onChange={() => toggleBenefit(benefit)}
              />
              <span className="text-sm">{benefit}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="border-t px-4 py-3 flex justify-end">
        <button
          onClick={() => {
            handleAddBenefits();
            setIsBenefitsOpen(false);
          }}
          className="rounded-[6px] bg-black text-white px-4 py-1.5 text-sm"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default EditBalanceCard
